import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { SeatingMapInitStepDeclaration } from "./Steps/SeatingMapInitStep";

export const SeatingMapStartupFlow = new FlowDefinition("SeatingMapFlow");

SeatingMapStartupFlow.addStep(SeatingMapInitStepDeclaration);

SeatingMapStartupFlow.setStartStep("SeatingMapInit_Step");

export const seatingMapStartupFlowDefinition = new StepDefinition({
    stepName: "SeatingMapFlow",
    stepFlow: SeatingMapStartupFlow,
    contextIsolation: false
})